import * as React from "react"
import * as ReactDOM from "react-dom"
import "./config"

import "react-redux-toastr/lib/css/react-redux-toastr.min.css"
import "./style/main.scss"
import "react-table/react-table.css"
import "react-checkbox-tree/lib/react-checkbox-tree.css"
import { $getRole, $getManagedSupplierList } from "./core/requests"

import { getConfiguration, IConfiguration, initConfig } from "./config"
import store from "./core/store"

import { Roles } from "./utils"

import Loader from "./ui/components/com_loader"
import Root from "./ui/root"
import { LocalStorageKeys } from "./utils/local-storage-keys"
import { transform, responseType } from "./utils/http-res-handler"
import { InteractionStatus, PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider, useIsAuthenticated, useMsal } from "@azure/msal-react"
import { getPca } from "./authProvider"
import { ISupplierInfo } from "./models"

ReactDOM.render(<Loader />, document.getElementById("root"))

initConfig().then(() => {
  const pca = getPca()
  if (!inIframe()) {
    ReactDOM.render(
      <MsalProvider instance={pca}>
        <RoleWrapper />,
      </MsalProvider>,
      document.getElementById("root")
    )
  }
})

const RoleWrapper = () => {
  const { instance, accounts, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const [resRole, setRole] = React.useState<Roles>()
  const [resList, setList] = React.useState<ISupplierInfo[]>([])

  React.useEffect(() => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      if (accounts[0]) {
        instance.setActiveAccount(accounts[0])
      } else {
        sessionStorage.clear()
        localStorage.clear()
        instance.loginRedirect().catch((e) => {
          instance.logoutRedirect()
          instance.handleRedirectPromise()
          console.log("IL Y A EU UNE ERREUR")
        })
      }
    } else if (!isAuthenticated && inProgress === InteractionStatus.None) {
      sessionStorage.clear()
      localStorage.clear()
      instance.loginRedirect().catch((e) => {
        instance.logoutRedirect()
        instance.handleRedirectPromise()
        console.log("IL Y A EU UNE ERREUR")
      })
    }
  }, [inProgress, isAuthenticated, accounts, instance])

  React.useEffect(() => {
    if (
      instance.getActiveAccount() &&
      isAuthenticated &&
      !resRole &&
      inProgress === InteractionStatus.None
    ) {
      $getRole()
        .then((res) => transform(res, {}, responseType.text))
        .then((role: Roles) => {
          $getManagedSupplierList()
            .then((res) => transform(res, {}, responseType.json))
            .then((list: ISupplierInfo[]) => {
              // console.log("init", {role,})
              setList(list)
              setRole(role)
            })
        })
    }
  }, [inProgress, isAuthenticated, accounts, instance])

  return (
    (resRole && (
      <Root store={store} role={resRole} managedSupplierList={resList} />
    )) || <></>
  )
}

const inIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
